"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../../../");
var context_1 = require("../../../../context");
var enums_1 = require("../../../../types/enums");
var utils_1 = require("../../../../utils");
var Card_1 = require("../../../Card");
var Tabs_1 = require("../../../Tabs/Tabs");
var SmartMeterAdviceInput_1 = __importDefault(require("../Fields/SmartMeterAdviceInput"));
exports.errorKeys = [
    'has_smart_meter',
    'has_smart_meter_other',
    'smart_meter_advice',
    'smart_meter_advice_other',
];
var SmartMeterForm = function (_a) {
    var tabId = _a.tabId;
    var _b, _c, _d, _e, _f, _g;
    var _h = context_1.useSemantics(), options = _h.options, trans = _h.trans;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var _j = formik_1.useFormikContext(), values = _j.values, errors = _j.errors;
    var _k = react_1.useState(((_b = errors.project) === null || _b === void 0 ? void 0 : _b.smart_meter) || {}), formErrors = _k[0], setFormErrors = _k[1];
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(formErrors, exports.errorKeys)); }, [formErrors]);
    react_1.useEffect(function () { var _a; return setFormErrors(((_a = errors.project) === null || _a === void 0 ? void 0 : _a.smart_meter) || {}); }, [
        (_c = errors.project) === null || _c === void 0 ? void 0 : _c.smart_meter,
    ]);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('project:slhh::headings.smart-meter'), subHeading: trans('project:slhh::headings.project') },
        react_1.default.createElement(__1.FormControl, { errors: (_e = (_d = errors.project) === null || _d === void 0 ? void 0 : _d.smart_meter) === null || _e === void 0 ? void 0 : _e.has_smart_meter, label: trans('project:slhh::labels.has-smart-meter'), showOther: values.project.smart_meter.has_smart_meter === enums_1.BooleanOther.OTHER, other: react_1.default.createElement(__1.FormControl, { errors: (_g = (_f = errors.project) === null || _f === void 0 ? void 0 : _f.smart_meter) === null || _g === void 0 ? void 0 : _g.has_smart_meter_other, label: trans('project:slhh::labels.has-smart-meter-other') },
                react_1.default.createElement(__1.TextArea, { fast: true, name: "project.smart_meter.has_smart_meter_other", maxLength: 5000 })) },
            react_1.default.createElement(__1.Select, { width: "xs", options: options.booleanOther(), name: "project.smart_meter.has_smart_meter" })),
        react_1.default.createElement(SmartMeterAdviceInput_1.default, null)));
};
exports.default = SmartMeterForm;
//# sourceMappingURL=SmartMeterForm.js.map